export const adminNavigationItems = [
  {
    path: '/admin',
    label: 'Dashboard',
    groupKey: 'dashboard',
    groupLabel: 'Dashboard',
    showBreadcrumb: false,
  },
  {
    path: '/admin/system-settings',
    label: 'System Settings',
    groupKey: 'settings',
    groupLabel: 'Settings',
    showBreadcrumb: true,
  },
  {
    path: '/admin/event-dates',
    label: 'Event Dates',
    groupKey: 'event-setup',
    groupLabel: 'Event Setup',
    showBreadcrumb: true,
  },
  {
    path: '/admin/event-admin',
    label: 'Event Admin',
    groupKey: 'event-setup',
    groupLabel: 'Event Setup',
    showBreadcrumb: true,
  },
  {
    path: '/admin/announcements',
    label: 'Announcements',
    groupKey: 'event-setup',
    groupLabel: 'Event Setup',
    showBreadcrumb: true,
  },
  {
    path: '/admin/affiliations',
    label: 'Affiliations',
    groupKey: 'event-setup',
    groupLabel: 'Event Setup',
    showBreadcrumb: true,
  },
  {
    path: '/admin/classes',
    label: 'Classes',
    groupKey: 'event-setup',
    groupLabel: 'Event Setup',
    showBreadcrumb: true,
  },
  {
    path: '/admin/recruiters',
    label: 'Recruiters',
    groupKey: 'event-setup',
    groupLabel: 'Event Setup',
    showBreadcrumb: true,
  },
  {
    path: '/admin/statuses',
    label: 'Statuses',
    groupKey: 'event-setup',
    groupLabel: 'Event Setup',
    showBreadcrumb: true,
  },
  {
    path: '/admin/activities',
    label: 'Activities',
    groupKey: 'event-setup',
    groupLabel: 'Event Setup',
    showBreadcrumb: true,
  },
  {
    path: '/admin/task-preferences',
    label: 'Task Preferences',
    groupKey: 'event-setup',
    groupLabel: 'Event Setup',
    showBreadcrumb: true,
  },
  {
    path: '/admin/assignment-priorities',
    label: 'Assignment Profiles',
    groupKey: 'event-setup',
    groupLabel: 'Event Setup',
    showBreadcrumb: true,
  },
  {
    path: '/admin/announcements',
    label: 'Announcements',
    groupKey: 'announcements',
    groupLabel: 'Event Setup',
    showBreadcrumb: true,
  },
  {
    path: '/admin/applicants',
    label: 'Applicants',
    groupKey: 'volunteers',
    groupLabel: 'Volunteers',
    showBreadcrumb: true,
  },
  {
    path: '/admin/email',
    label: 'Emails',
    groupKey: 'volunteers',
    groupLabel: 'Volunteers',
    showBreadcrumb: true,
  },
  {
    path: '/admin/email-log',
    label: 'Email Log',
    groupKey: 'volunteers',
    groupLabel: 'Volunteers',
    showBreadcrumb: true,
  },
  {
    path: '/admin/interactive-assignment',
    label: 'Interactive Assignment',
    groupKey: 'assignments',
    groupLabel: 'Assignments',
    showBreadcrumb: true,
  },
  {
    path: '/admin/final-assignment',
    label: 'Final Assignments',
    groupKey: 'assignments',
    groupLabel: 'Assignments',
    showBreadcrumb: true,
  },
  {
    path: '/admin/era',
    label: 'ERA',
    groupKey: 'assignments',
    groupLabel: 'Assignments',
    showBreadcrumb: true,
  },
  {
    path: '/admin/bb',
    label: 'BB',
    groupKey: 'assignments',
    groupLabel: 'Assignments',
    showBreadcrumb: true,
  },
  {
    path: '/admin/users',
    label: 'Users',
    groupKey: 'workzone',
    groupLabel: 'Workzone',
    showBreadcrumb: true,
  },
];

const defaultItem = adminNavigationItems[0];

export const findAdminNavigationItem = (pathname) => {
  const matchedItem = adminNavigationItems.find((item) => item.path === pathname);

  return matchedItem || defaultItem;
};

export const shouldShowAdminBreadcrumb = (pathname) => findAdminNavigationItem(pathname).showBreadcrumb;

export const getAdminSiblingItems = (pathname) => {
  const currentItem = findAdminNavigationItem(pathname);

  return adminNavigationItems.filter((item) => item.groupKey === currentItem.groupKey)
                             .map((item) => ({ ...item, disabled: item.path === currentItem.path }));
};
